/*!
 * Sleepy Hearts Maze — Katie & Laura Arcade
 * Theme assets remain drawer-maze.js / drawer-maze.css (same parlor page / handle).
 * Vanilla HTML5 canvas · procedural Web Audio · no trademarks
 */
(function (global) {
  'use strict';

  var COLS = 11;
  var ROWS = 13;
  var TILE = 46;
  var HUD_H = 28;
  var W = COLS * TILE; // 506
  var H = HUD_H + ROWS * TILE; // 626
  var HS_KEY = 'kl_highscore_sleepy_hearts';
  var HS_KEY_LEGACY = 'kl_highscore_drawer_maze';
  var MUTE_KEY = 'kl_mute';

  var DIRS = {
    up:    { x: 0, y: -1, name: 'up' },
    down:  { x: 0, y: 1, name: 'down' },
    left:  { x: -1, y: 0, name: 'left' },
    right: { x: 1, y: 0, name: 'right' }
  };
  var OPP = { up: 'down', down: 'up', left: 'right', right: 'left' };

  // Mobile: 11×13 hard-coded solvable boards (−112 cells vs prior 15×17). # wall . dot o bag P spawn H hamper E exit B bra W puddle J pearl
  var MAZES_MOBILE = [
    [
      '###########',
      '#.........#',
      '#o##.#.##o#',
      '#.........#',
      '#.##.#.##.#',
      '#....B....#',
      '###.# #.###',
      '#...HHH...#',
      '###.#H#.###',
      '#....P....#',
      '#o#.#W#.#o#',
      '#..J#E#J..#',
      '###########'
    ],
    [
      '###########',
      '#o.......o#',
      '#.###.###.#',
      '#...#.#...#',
      '#.#...#.#.#',
      '#.#.B.....#',
      '#.#.# #.#.#',
      '#...HHH...#',
      '#.#.#H#.#.#',
      '#....P....#',
      '#o#.#W#.#o#',
      '#..J#E#J..#',
      '###########'
    ],
    [
      '###########',
      '#..o...o..#',
      '#.###.#.###',
      '#.....#...#',
      '###.#.###.#',
      '#...B....W#',
      '###.# #.###',
      '#..HHH....#',
      '##..#H#..##',
      '#.W.P.....#',
      '#o.#...#.o#',
      '#..J#E#J..#',
      '###########'
    ]
  ];

  // Desktop: wide 19×13 hard-coded solvable boards for landscape play.
  var MAZES_DESKTOP = [
    [
      '###################',
      '#.................#',
      '#o.###.......###.o#',
      '#..#...........#..#',
      '#..###.......###..#',
      '#....#B.....W#....#',
      '#.###...# #...###.#',
      '#..#....HHH....#..#',
      '#.###...#H#...###.#',
      '#..###.......###..#',
      '#..#.....P.....#..#',
      '#...J....E....J...#',
      '###################'
    ],
    [
      '###################',
      '#.o.............o.#',
      '#.###.........###.#',
      '#.#.#.........#.#.#',
      '#.###.........###.#',
      '#.#..B.......W..#.#',
      '#....#### ####....#',
      '#....#..HHH..#....#',
      '#....####H####....#',
      '#.###.........###.#',
      '#.#......P......#.#',
      '#..J.....E.....J..#',
      '###################'
    ],
    [
      '###################',
      '#.................#',
      '#....###...###....#',
      '#o...#.......#...o#',
      '#....###...###....#',
      '#..B.#.......#.W..#',
      '#.###...# #...###.#',
      '#..#....HHH....#..#',
      '#.###...#H#...###.#',
      '#....###...###....#',
      '#....#...P...#....#',
      '#.....J..E..J.....#',
      '###################'
    ]
  ];
  var MAZES = MAZES_MOBILE;

  var MOBILE_LAYOUT = { mode: 'mobile', cols: 11, rows: 13, tile: 46, width: 506, height: 626, mazes: MAZES_MOBILE };
  var DESKTOP_LAYOUT = { mode: 'desktop', cols: 19, rows: 13, tile: 34, width: 646, height: 470, mazes: MAZES_DESKTOP };
  var layoutMode = 'mobile';
  var LAYOUT_QUERY = '(max-width: 720px), (pointer: coarse) and (max-width: 989px)';

  function isMobileLayout() {
    return !global.matchMedia || global.matchMedia(LAYOUT_QUERY).matches;
  }
  function layoutModeForViewport() {
    return isMobileLayout() ? 'mobile' : 'desktop';
  }
  function setLayoutMode(mode) {
    var cfg = mode === 'desktop' ? DESKTOP_LAYOUT : MOBILE_LAYOUT;
    layoutMode = cfg.mode;
    COLS = cfg.cols;
    ROWS = cfg.rows;
    TILE = cfg.tile;
    W = cfg.width;
    H = cfg.height;
    MAZES = cfg.mazes;
    if (global.KLSleepyHeartsMaze) {
      global.KLSleepyHeartsMaze.TILE = TILE;
      global.KLSleepyHeartsMaze.W = W;
      global.KLSleepyHeartsMaze.H = H;
    }
  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function manhattan(ax, ay, bx, by) { return Math.abs(ax - bx) + Math.abs(ay - by); }
  function dirFromName(n) { return DIRS[n] || null; }
  function opposite(n) { return OPP[n]; }

  // --- Audio ---
  function AudioBus() {
    this.ctx = null;
    this.muted = false;
    try {
      this.muted = localStorage.getItem(MUTE_KEY) === '1';
    } catch (e) {}
  }
  AudioBus.prototype.ensure = function () {
    if (!this.ctx) {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return null;
      this.ctx = new AC();
    }
    if (this.ctx.state === 'suspended') this.ctx.resume();
    return this.ctx;
  };
  AudioBus.prototype.setMute = function (m) {
    this.muted = !!m;
    try { localStorage.setItem(MUTE_KEY, this.muted ? '1' : '0'); } catch (e) {}
  };
  AudioBus.prototype.toggleMute = function () {
    this.setMute(!this.muted);
    return this.muted;
  };
  AudioBus.prototype.beep = function (freq, dur, type, vol, slideTo) {
    if (this.muted) return;
    var ctx = this.ensure();
    if (!ctx) return;
    var t0 = ctx.currentTime;
    var o = ctx.createOscillator();
    var g = ctx.createGain();
    o.type = type || 'square';
    o.frequency.setValueAtTime(freq, t0);
    if (slideTo != null) o.frequency.exponentialRampToValueAtTime(Math.max(20, slideTo), t0 + dur);
    g.gain.setValueAtTime(vol == null ? 0.06 : vol, t0);
    g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
    o.connect(g); g.connect(ctx.destination);
    o.start(t0); o.stop(t0 + dur + 0.02);
  };
  AudioBus.prototype.noiseBurst = function (dur, vol) {
    if (this.muted) return;
    var ctx = this.ensure();
    if (!ctx) return;
    var n = Math.floor(ctx.sampleRate * dur);
    var buf = ctx.createBuffer(1, n, ctx.sampleRate);
    var data = buf.getChannelData(0);
    for (var i = 0; i < n; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / n);
    var src = ctx.createBufferSource();
    src.buffer = buf;
    var g = ctx.createGain();
    g.gain.value = vol == null ? 0.08 : vol;
    var f = ctx.createBiquadFilter();
    f.type = 'bandpass'; f.frequency.value = 900; f.Q.value = 0.6;
    src.connect(f); f.connect(g); g.connect(ctx.destination);
    src.start();
  };
  AudioBus.prototype.waka = function (alt) {
    this.beep(alt ? 420 : 520, 0.07, 'square', 0.045);
  };
  AudioBus.prototype.pellet = function () {
    var self = this;
    [523, 659, 784, 1046].forEach(function (f, i) {
      setTimeout(function () { self.beep(f, 0.08, 'square', 0.05); }, i * 55);
    });
  };
  AudioBus.prototype.eatChaser = function () {
    this.beep(180, 0.12, 'square', 0.07, 520);
  };
  AudioBus.prototype.death = function () {
    this.beep(440, 0.45, 'sawtooth', 0.07, 60);
  };
  AudioBus.prototype.dye = function () {
    this.noiseBurst(0.35, 0.1);
    this.beep(220, 0.25, 'triangle', 0.05, 110);
  };
  AudioBus.prototype.extraLife = function () {
    this.beep(880, 0.12, 'square', 0.06);
    var self = this;
    setTimeout(function () { self.beep(1175, 0.18, 'square', 0.06); }, 100);
  };
  AudioBus.prototype.fanfare = function () {
    var self = this;
    [523, 659, 784, 1046].forEach(function (f, i) {
      setTimeout(function () { self.beep(f, 0.12, 'triangle', 0.055); }, i * 90);
    });
  };

  // --- Game ---
  function Game(root) {
    this.root = root;
    this.canvas = root.querySelector('#kl-dm-canvas') || root.querySelector('canvas');
    if (!this.canvas) {
      this.canvas = document.createElement('canvas');
      this.canvas.width = W;
      this.canvas.height = H;
      var stage = root.querySelector('[data-kl-dm-stage]') || root;
      stage.appendChild(this.canvas);
    }
    // The Liquid canvas starts at the mobile size; JS owns the active layout size.
    this.canvas.width = W;
    this.canvas.height = H;
    this.ctx = this.canvas.getContext('2d');
    this.ctx.imageSmoothingEnabled = false;
    this.hintEl = root.querySelector('[data-kl-dm-hint]');
    this.audio = new AudioBus();
    this.state = 'ATTRACT';
    this.highScore = 0;
    try {
      this.highScore = parseInt(localStorage.getItem(HS_KEY) || '0', 10) || 0;
      if (!this.highScore) {
        var legacy = parseInt(localStorage.getItem(HS_KEY_LEGACY) || '0', 10) || 0;
        if (legacy) {
          this.highScore = legacy;
          try { localStorage.setItem(HS_KEY, String(legacy)); } catch (e2) {}
        }
      }
    } catch (e) {}
    this.score = 0;
    this.lives = 10;
    this.board = 0;
    this.extraLifeGiven = false;
    this.keys = Object.create(null);
    this.wantDir = null;
    this.toast = null;
    this.toastT = 0;
    this.dyeT = 0;
    this.blackoutT = 0;
    this.frightT = 0;
    this.frightChain = 0;
    this.deathT = 0;
    this.winT = 0;
    this.wakaAlt = false;
    this.wakaCD = 0;
    this.smears = []; // {x,y,t}
    this.frame = 0;
    this.lastTs = 0;
    this.attractBlink = 0;
    this.grid = null;
    this.dotsLeft = 0;
    this.player = null;
    this.chasers = null;
    this.exitOpen = false;
    this.skidTurns = 0;
    this.dyedWhite = false;
    this.padHeld = null;

    this._bindInput();
    this._destroyed = false;
    this._raf = 0;
    this._drawScale = 1;
    this._resize();
    this._goAttract();
    /* First paint + post-joystick/fonts layout: same path as window resize. */
    this._scheduleLayoutFit();
    var self = this;
    if (global.document && global.document.fonts && global.document.fonts.ready) {
      try {
        global.document.fonts.ready.then(function () {
          if (!self._destroyed) self._scheduleLayoutFit();
        });
      } catch (eFonts) {}
    }
    this._raf = requestAnimationFrame(function loop(ts) {
      if (self._destroyed) return;
      self._tick(ts);
      self._raf = requestAnimationFrame(loop);
    });
  }

  Game.prototype.destroy = function () {
    this._destroyed = true;
    if (this._raf) {
      try { cancelAnimationFrame(this._raf); } catch (e) {}
      this._raf = 0;
    }
  };


  /* iOS Safari: block Copy / Find Selection / Translate long-press callout on pad/canvas.
     Canvas/pad containers may cancel touchstart; pad buttons stay cancel-free so iOS
     still dispatches their pointer/click activation. */
  /* Vanilla port of virtual-joystick.tsx — analog stick, x/y in [-1,1]. */
  function mountVirtualJoystick(root, onChange, opts) {
    opts = opts || {};
    var size = opts.size || 124;
    var well = root.querySelector(".kl-vj__well") || root;
    var knob = root.querySelector("[data-kl-vj-knob]");
    var pid = null;
    var r = size * 0.32;
    well.style.width = size + "px";
    well.style.height = size + "px";
    if (knob) {
      knob.style.width = size * 0.36 + "px";
      knob.style.height = size * 0.36 + "px";
    }
    function send(x, y) {
      if (knob) {
        knob.style.transform =
          "translate(calc(-50% + " + x * r + "px), calc(-50% + " + y * r + "px))";
      }
      onChange(x, y);
    }
    function fromEvent(e) {
      var b = well.getBoundingClientRect();
      var cx = b.left + b.width / 2;
      var cy = b.top + b.height / 2;
      var dx = e.clientX - cx;
      var dy = e.clientY - cy;
      var max = b.width * 0.32;
      var mag = Math.hypot(dx, dy);
      if (mag > max && mag > 0) {
        dx = (dx / mag) * max;
        dy = (dy / mag) * max;
      }
      send(dx / max, dy / max);
    }
    function down(e) {
      e.preventDefault();
      pid = e.pointerId;
      try {
        well.setPointerCapture(e.pointerId);
      } catch (err) {}
      fromEvent(e);
    }
    function move(e) {
      if (pid !== e.pointerId) return;
      fromEvent(e);
    }
    function up(e) {
      if (pid !== null && e.pointerId !== undefined && pid !== e.pointerId) return;
      pid = null;
      send(0, 0);
    }
    well.addEventListener("pointerdown", down);
    well.addEventListener("pointermove", move);
    well.addEventListener("pointerup", up);
    well.addEventListener("pointercancel", up);
    well.addEventListener("lostpointercapture", up);
  }

  function suppressIosCallout(el, touchPrevent) {
    if (!el || el.__klNoCallout) return;
    el.__klNoCallout = true;
    var stop = function (ev) {
      ev.preventDefault();
    };
    el.addEventListener('contextmenu', stop, false);
    el.addEventListener('selectstart', stop, false);
    if (touchPrevent) {
      el.addEventListener(
        'touchstart',
        function (ev) {
          if (ev.cancelable) ev.preventDefault();
        },
        { passive: false }
      );
    }
  }

  Game.prototype._bindInput = function () {
    var self = this;

    // Stronger anti-callout on root / stage / canvas / pad / buttons (Katie iPhone playtest)
    suppressIosCallout(this.root, false);
    suppressIosCallout(this.root.querySelector('.kl-dm__stage'), false);
    suppressIosCallout(this.canvas, true);
    var padEl = this.root.querySelector('[data-kl-dm-pad]') || this.root.querySelector('.kl-dm__pad');
    suppressIosCallout(padEl, true);
    // Keep D-pad/start buttons touchstart-cancel-free so iOS dispatches pointer/click
    // activation; their pointer handlers prevent the active event when needed.
    this.root.querySelectorAll('.kl-dm__btn, [data-dir], [data-action]').forEach(function (btn) {
      suppressIosCallout(btn, false);
    });

    function setDir(name) {
      self.wantDir = name;
      if (self.state === 'ATTRACT' || self.state === 'GAMEOVER') self._startGame();
      else if (self.state === 'PAUSED') self._setState('PLAYING');
    }
    global.addEventListener('keydown', function (e) {
      var k = e.key.toLowerCase();
      if (k === 'arrowup' || k === 'w') { e.preventDefault(); setDir('up'); self.keys.up = true; }
      else if (k === 'arrowdown' || k === 's') { e.preventDefault(); setDir('down'); self.keys.down = true; }
      else if (k === 'arrowleft' || k === 'a') { e.preventDefault(); setDir('left'); self.keys.left = true; }
      else if (k === 'arrowright' || k === 'd') { e.preventDefault(); setDir('right'); self.keys.right = true; }
      else if (k === ' ' || k === 'enter') {
        e.preventDefault();
        self.audio.ensure();
        if (self.state === 'ATTRACT' || self.state === 'GAMEOVER') self._startGame();
        else if (self.state === 'PAUSED') self._setState('PLAYING');
        else if (self.state === 'PLAYING') { /* ignore fire */ }
      } else if (k === 'escape' || k === 'p') {
        e.preventDefault();
        if (self.state === 'PLAYING') { self._setState('PAUSED'); self._toast('Paused.', 1.2); }
        else if (self.state === 'PAUSED') self._setState('PLAYING');
      } else if (k === 'm') {
        e.preventDefault();
        var muted = self.audio.toggleMute();
        self._toast(muted ? 'Muted.' : 'Sound on.', 1);
      }
    });
    global.addEventListener('keyup', function (e) {
      var k = e.key.toLowerCase();
      if (k === 'arrowup' || k === 'w') self.keys.up = false;
      if (k === 'arrowdown' || k === 's') self.keys.down = false;
      if (k === 'arrowleft' || k === 'a') self.keys.left = false;
      if (k === 'arrowright' || k === 'd') self.keys.right = false;
    });

    var pad = this.root.querySelector('[data-kl-dm-pad]');
    if (pad) {
      /* Virtual stick: snap to 4-way (React drawer-maze.tsx). */
      var vjEl = pad.querySelector('[data-kl-vj]');
      if (vjEl) {
        suppressIosCallout(vjEl.querySelector('.kl-vj__well') || vjEl, true);
        mountVirtualJoystick(vjEl, function (x, y) {
          self.audio.ensure();
          /* Any stick touch (incl. center tap inside deadzone) starts from ATTRACT/GAMEOVER. */
          if (self.state === 'ATTRACT' || self.state === 'GAMEOVER') {
            self._startGame();
          }
          if (Math.hypot(x, y) < 0.32) {
            self.padHeld = null;
            return;
          }
          var dir;
          if (Math.abs(x) > Math.abs(y)) dir = x < 0 ? 'left' : 'right';
          else dir = y < 0 ? 'up' : 'down';
          self.padHeld = dir;
          setDir(dir);
        }, { size: 124 });
      }
      /* Legacy D-pad buttons (if any remain) */
      pad.querySelectorAll('[data-dir]').forEach(function (btn) {
        var dir = btn.getAttribute('data-dir');
        function down(ev) {
          ev.preventDefault();
          try { btn.setPointerCapture(ev.pointerId); } catch (e) {}
          self.audio.ensure();
          self.padHeld = dir;
          setDir(dir);
          btn.classList.add('is-down');
        }
        function up(ev) {
          ev.preventDefault();
          if (self.padHeld === dir) self.padHeld = null;
          btn.classList.remove('is-down');
        }
        btn.addEventListener('pointerdown', down);
        btn.addEventListener('pointerup', up);
        btn.addEventListener('pointercancel', up);
        btn.addEventListener('lostpointercapture', up);
      });
      var startBtn = pad.querySelector('[data-action="start"]');
      if (startBtn) {
        startBtn.addEventListener('pointerdown', function (ev) {
          ev.preventDefault();
          self.audio.ensure();
          if (self.state === 'ATTRACT' || self.state === 'GAMEOVER') self._startGame();
          else if (self.state === 'PAUSED') self._setState('PLAYING');
          else if (self.state === 'PLAYING') {
            self._setState('PAUSED');
            self._toast('Paused.', 1.2);
          }
        });
      }
    }

    // First tap unlocks audio
    this.root.addEventListener('pointerdown', function () { self.audio.ensure(); }, { once: true });
    global.addEventListener('resize', function () { self._layoutFit(); });
    global.addEventListener('orientationchange', function () { self._scheduleLayoutFit(); });
  };

  Game.prototype._setState = function (next) {
    this.state = next;
    var playState = next === 'PLAYING' || next === 'PAUSED' || next === 'DYING' || next === 'WIN_WAVE';
    if (this.root) this.root.classList.toggle('is-playing', playState);
    var page = this.root && this.root.closest ? this.root.closest('.kl-drawer-maze-page') : null;
    if (page) page.classList.toggle('is-playing', playState);
  };

  Game.prototype._syncLayout = function () {
    var nextMode = layoutModeForViewport();
    if (nextMode === layoutMode) return;
    var currentBoard = this.board;
    var currentState = this.state;
    setLayoutMode(nextMode);
    this.canvas.width = W;
    this.canvas.height = H;
    this._loadBoard(currentBoard, currentState === 'ATTRACT');
    this._resize();
  };

  /* Same path as window resize: sync layout mode + refit bitmap/CSS to stage. */
  Game.prototype._layoutFit = function () {
    this._syncLayout();
    this._resize();
  };

  /* DOM/fonts/joystick/Start can settle after first paint — refit after layout. */
  Game.prototype._scheduleLayoutFit = function () {
    var self = this;
    if (self._destroyed) return;
    self._layoutFit();
    if (global.requestAnimationFrame) {
      global.requestAnimationFrame(function () {
        if (self._destroyed) return;
        self._layoutFit();
        global.requestAnimationFrame(function () {
          if (self._destroyed) return;
          self._layoutFit();
        });
      });
    } else {
      global.setTimeout(function () { if (!self._destroyed) self._layoutFit(); }, 0);
    }
  };

  Game.prototype._fitScale = function () {
    /* Letterbox to stage (width AND height). Avoid intrinsic-size postage stamp. */
    var stage = this.root && this.root.querySelector
      ? this.root.querySelector('[data-kl-dm-stage]') || this.canvas.parentElement
      : this.canvas.parentElement;
    var availW = 0;
    var availH = 0;
    if (stage) {
      availW = stage.clientWidth || 0;
      availH = stage.clientHeight || 0;
    }
    if (availW < 32) availW = (this.canvas.clientWidth || W);
    if (availH < 32) {
      /* Stage not flex-sized yet — fallback to viewport above pad reserve */
      var reserve = 180;
      try {
        var cs = global.getComputedStyle && this.root
          ? global.getComputedStyle(this.root)
          : null;
        if (cs) {
          var r = cs.getPropertyValue('--kl-dm-play-reserve');
          if (r) reserve = parseFloat(r) || reserve;
        }
      } catch (e) {}
      var vh = global.innerHeight || H;
      availH = Math.max(120, vh - reserve);
    }
    var scale = Math.min(availW / W, availH / H);
    if (!isFinite(scale) || scale <= 0) scale = 1;
    if (scale > 4) scale = 4;
    if (scale < 0.2) scale = 0.2;
    return scale;
  };

  Game.prototype._resize = function () {
    var dpr = Math.min(global.devicePixelRatio || 1, 2);
    var scale = this._fitScale();
    var cssW = Math.max(1, Math.round(W * scale));
    var cssH = Math.max(1, Math.round(H * scale));
    /* Explicit CSS size so canvas scales into stage (width:auto stayed at intrinsic). */
    this.canvas.style.width = cssW + 'px';
    this.canvas.style.height = cssH + 'px';
    this.canvas.style.maxWidth = '100%';
    this.canvas.style.maxHeight = '100%';
    this._drawScale = scale;
    var bw = Math.round(W * dpr * scale);
    var bh = Math.round(H * dpr * scale);
    if (this.canvas.width !== bw || this.canvas.height !== bh) {
      this.canvas.width = bw;
      this.canvas.height = bh;
    }
    this.ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);
    this.ctx.imageSmoothingEnabled = false;
  };

  Game.prototype._toast = function (msg, sec) {
    this.toast = msg;
    this.toastT = sec || 2;
    if (this.hintEl) this.hintEl.textContent = msg;
  };

  Game.prototype._goAttract = function () {
    this._setState('ATTRACT');
    this.board = 0;
    this._loadBoard(0, true);
    this._toast('Night-night, cuties.', 2);
    this._scheduleLayoutFit();
  };

  Game.prototype._startGame = function () {
    this.audio.ensure();
    this.score = 0;
    this.lives = 10;
    this.board = 0;
    this.extraLifeGiven = false;
    this._setState('PLAYING');
    this._loadBoard(0, false);
    this._toast('Night-night, cuties.', 1.5);
    /* Flex stage size is wrong until after paint — refit like window resize. */
    this._scheduleLayoutFit();
  };

  Game.prototype._loadBoard = function (idx, demo) {
    var layout = MAZES[idx % MAZES.length];
    this.boardIndex = idx;
    this.grid = [];
    this.dotsLeft = 0;
    this.smears = [];
    this.dyeT = 0;
    this.blackoutT = 0;
    this.frightT = 0;
    this.frightChain = 0;
    this.exitOpen = false;
    this.skidTurns = 0;
    var spawn = layoutMode === 'desktop' ? { x: 9, y: 10 } : { x: 5, y: 9 };
    var hamper = [];
    var exit = layoutMode === 'desktop' ? { x: 9, y: 11 } : { x: 5, y: 11 };
    var whiteDots = [];

    for (var y = 0; y < ROWS; y++) {
      var row = layout[y];
      if (row.length !== COLS) {
        console.warn('Maze row length', y, row.length);
      }
      this.grid[y] = [];
      for (var x = 0; x < COLS; x++) {
        var ch = row[x] || '#';
        var cell = { wall: false, dot: false, bag: false, hamper: false, exit: false, bra: false, puddle: false, pearl: false, white: false, eaten: false };
        if (ch === '#') cell.wall = true;
        else if (ch === '.') { cell.dot = true; this.dotsLeft++; }
        else if (ch === 'o') { cell.bag = true; }
        else if (ch === 'P') { spawn = { x: x, y: y }; }
        else if (ch === 'H') { cell.hamper = true; hamper.push({ x: x, y: y }); }
        else if (ch === 'E') { cell.exit = true; exit = { x: x, y: y }; }
        else if (ch === 'B') { cell.bra = true; }
        else if (ch === 'W') { cell.puddle = true; }
        else if (ch === 'J') { cell.pearl = true; }
        // spaces and letters that are walkable stay empty
        if (ch === ' ' || ch === 'P' || ch === 'H' || ch === 'E' || ch === 'B' || ch === 'W' || ch === 'J') {
          /* walkable */
        }
        this.grid[y][x] = cell;
      }
    }

    // Mark ~30% of heart-dots as soft-frost (vulnerable to nightmare blush)
    var dotList = [];
    for (y = 0; y < ROWS; y++) {
      for (x = 0; x < COLS; x++) {
        if (this.grid[y][x].dot) dotList.push({ x: x, y: y });
      }
    }
    // Deterministic-ish shuffle by board index
    var seed = (idx + 1) * 9973;
    function rnd() { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; }
    for (var i = dotList.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1));
      var tmp = dotList[i]; dotList[i] = dotList[j]; dotList[j] = tmp;
    }
    var nWhite = Math.floor(dotList.length * 0.3);
    for (i = 0; i < nWhite; i++) {
      this.grid[dotList[i].y][dotList[i].x].white = true;
    }

    if (!hamper.length) {
      hamper = layoutMode === 'desktop'
        ? [{ x: 8, y: 7 }, { x: 9, y: 7 }, { x: 10, y: 7 }, { x: 9, y: 8 }]
        : [{ x: 4, y: 7 }, { x: 5, y: 7 }, { x: 6, y: 7 }, { x: 5, y: 8 }];
    }
    this.spawn = spawn;
    this.exit = exit;
    this.hamperTiles = hamper;

    // Ease in the first drawers (board 1 clearly slower); gentle ramp; late boards keep established feel.
    var baseSpeed = idx === 0 ? 3.6 : idx === 1 ? 4.6 : idx === 2 ? 6 : idx === 3 ? 7.25 : 8; // tiles/sec
    this.playerSpeed = baseSpeed;
    var chaserFrac = idx === 0 ? 0.55 : idx === 1 ? 0.60 : idx === 2 ? 0.72 : idx >= 4 ? 1.0 : 0.85;
    this.chaserSpeed = baseSpeed * chaserFrac;

    this.player = {
      x: spawn.x, y: spawn.y,
      px: spawn.x, py: spawn.y,
      dir: 'left',
      moving: false,
      progress: 0,
      slideLeft: 0,
      overshoot: 0
    };

    var names = [
      { id: 'alarm', name: 'Alarm Clock', color: '#e8a0b8', delay: 1 },
      { id: 'nightmare', name: 'Nightmare', color: '#9b7bb8', delay: 3 },
      { id: 'sock', name: 'Lost Sock', color: '#7a8aa0', delay: 5 },
      { id: 'coldfeet', name: 'Cold Feet', color: '#c9a46a', delay: 7 }
    ];
    var hx = hamper[1] ? hamper[1].x : hamper[0].x;
    var hy = hamper[1] ? hamper[1].y : hamper[0].y;
    this.chasers = names.map(function (n, i) {
      var spot = hamper[i] || hamper[hamper.length - 1];
      return {
        id: n.id,
        name: n.name,
        color: n.color,
        x: spot.x, y: spot.y,
        px: spot.x, py: spot.y,
        dir: 'up',
        progress: 0,
        moving: false,
        mode: 'house', // house | chase | scatter | fright | eyes
        houseT: n.delay,
        fright: false,
        speedMul: n.id === 'coldfeet' ? 0.7 : 1,
        blackoutCD: 8,
        patrolPhase: i,
        alive: true
      };
    });

    // Count bags
    this.bagsLeft = 0;
    for (y = 0; y < ROWS; y++) for (x = 0; x < COLS; x++) if (this.grid[y][x].bag) this.bagsLeft++;
  };

  Game.prototype._cell = function (x, y) {
    if (x < 0 || y < 0 || x >= COLS || y >= ROWS) return null;
    return this.grid[y][x];
  };

  Game.prototype._walkable = function (x, y, forChaser) {
    var c = this._cell(x, y);
    if (!c || c.wall) return false;
    // Exit tiles stay walkable even when locked; win gate is in _playerArrived.
    // Chasers can enter hamper; player can too
    return true;
  };

  Game.prototype._openNeighbors = function (x, y, forChaser) {
    var out = [];
    ['up', 'down', 'left', 'right'].forEach(function (d) {
      var dir = DIRS[d];
      var nx = x + dir.x, ny = y + dir.y;
      if (this._walkable(nx, ny, forChaser)) out.push(d);
    }, this);
    return out;
  };

  Game.prototype._atCenter = function (ent) {
    return !ent.moving && Math.abs(ent.px - ent.x) < 0.01 && Math.abs(ent.py - ent.y) < 0.01;
  };

  Game.prototype._beginMove = function (ent, dirName, speed) {
    var dir = DIRS[dirName];
    if (!dir) return false;
    var nx = ent.x + dir.x, ny = ent.y + dir.y;
    var forChaser = ent.id != null;
    if (!this._walkable(nx, ny, forChaser)) return false;
    ent.dir = dirName;
    ent.tx = nx; ent.ty = ny;
    ent.fx = ent.x; ent.fy = ent.y;
    ent.moving = true;
    ent.progress = 0;
    ent.moveSpeed = speed;
    return true;
  };

  Game.prototype._stepEntity = function (ent, dt, speed) {
    if (!ent.moving) return;
    var sp = (ent.moveSpeed != null ? ent.moveSpeed : speed);
    if (ent.overshoot > 0) {
      sp *= 1.35;
    }
    ent.progress += sp * dt;
    var p = Math.min(1, ent.progress);
    ent.px = ent.fx + (ent.tx - ent.fx) * p;
    ent.py = ent.fy + (ent.ty - ent.fy) * p;
    if (ent.progress >= 1) {
      ent.x = ent.tx; ent.y = ent.ty;
      ent.px = ent.x; ent.py = ent.y;
      ent.moving = false;
      ent.progress = 0;
      if (ent.overshoot > 0) ent.overshoot = Math.max(0, ent.overshoot - 1);
      return true; // arrived
    }
    return false;
  };

  Game.prototype._playerArrived = function () {
    var p = this.player;
    var c = this._cell(p.x, p.y);
    if (!c) return;

    if (c.dot && !c.eaten) {
      c.eaten = true;
      c.dot = false;
      this.dotsLeft--;
      var pts = c.white && this.dyedWhite ? 0 : 10;
      this._addScore(pts);
      if (pts > 0) {
        this.wakaCD = 0;
        this.audio.waka(this.wakaAlt);
        this.wakaAlt = !this.wakaAlt;
      }
      if (this.dotsLeft <= 0) {
        this.exitOpen = true;
        this._toast('Bedroom door unlocked.', 1.5);
      }
    }
    if (c.bag) {
      c.bag = false;
      this.bagsLeft = Math.max(0, this.bagsLeft - 1);
      this._addScore(50);
      this.audio.pellet();
      this._powerUp();
    }
    if (c.bra) {
      c.bra = false;
      this._addScore(200);
      this._toast('Extra pillow. Cozy.', 1.5);
    }
    if (c.exit && this.exitOpen) {
      this._onLockedExit = false;
      this._boardClear();
      return;
    }
    if (c.exit && !this.exitOpen) {
      if (!this._onLockedExit) {
        this._onLockedExit = true;
        this._toast('Door still locked.', 1.5);
      }
    } else {
      this._onLockedExit = false;
    }
    if (c.puddle) {
      p.slideLeft = 1; // force one more tile in current dir
      this._toast('Moon puddle. Soft slide.', 1.2);
    }

    // Alarm buzz skid
    for (var i = this.smears.length - 1; i >= 0; i--) {
      var s = this.smears[i];
      if (s.x === p.x && s.y === p.y) {
        this.skidTurns = 2;
        this._toast('Alarm buzz. Skiddy toes.', 1.4);
      }
    }
  };

  Game.prototype._powerUp = function () {
    this.frightT = 6;
    this.frightChain = 0;
    this.chasers.forEach(function (ch) {
      if (ch.mode === 'eyes' || ch.mode === 'house') return;
      ch.fright = true;
      ch.mode = 'fright';
      // reverse once
      var opp = opposite(ch.dir);
      if (!ch.moving) {
        var opts = this._openNeighbors(ch.x, ch.y, true);
        if (opts.indexOf(opp) >= 0) ch.dir = opp;
      } else {
        // swap target mid-move roughly by reversing intent
        ch.dir = opp;
      }
    }, this);
  };

  Game.prototype._addScore = function (n) {
    if (n <= 0) return;
    this.score += n;
    if (!this.extraLifeGiven && this.score >= 10000) {
      this.extraLifeGiven = true;
      this.lives++;
      this.audio.extraLife();
      this._toast('Extra heart. Soft.', 1.5);
    }
    if (this.score > this.highScore) {
      this.highScore = this.score;
      try { localStorage.setItem(HS_KEY, String(this.highScore)); } catch (e) {}
    }
  };

  Game.prototype._boardClear = function () {
    this._addScore(500);
    this.audio.fanfare();
    this._setState('WIN_WAVE');
    this.winT = 1.5;
    this._toast('Bedroom found.', 1.5);
  };

  Game.prototype._nextBoard = function () {
    this.board++;
    this._setState('PLAYING');
    this._loadBoard(this.board, false);
  };

  Game.prototype._updatePlayer = function (dt) {
    var p = this.player;
    var speed = this.playerSpeed;

    // Queued dir from pad/keys
    if (this.padHeld) this.wantDir = this.padHeld;
    else {
      if (this.keys.up) this.wantDir = 'up';
      else if (this.keys.down) this.wantDir = 'down';
      else if (this.keys.left) this.wantDir = 'left';
      else if (this.keys.right) this.wantDir = 'right';
    }

    if (!p.moving) {
      var chosen = null;
      // Pearl tile: 30% chance to ignore direction change
      var cell = this._cell(p.x, p.y);
      var pearlBlock = cell && cell.pearl && Math.random() < 0.3;

      if (p.slideLeft > 0) {
        chosen = p.dir;
        p.slideLeft--;
      } else if (this.wantDir && !pearlBlock) {
        if (this._walkable(p.x + DIRS[this.wantDir].x, p.y + DIRS[this.wantDir].y, false)) {
          chosen = this.wantDir;
        }
      }
      if (!chosen) {
        if (this._walkable(p.x + DIRS[p.dir].x, p.y + DIRS[p.dir].y, false)) chosen = p.dir;
      }
      if (chosen) {
        if (this.skidTurns > 0 && chosen !== p.dir) {
          p.overshoot = 1; // extra velocity once per accepted turn after smear
          this.skidTurns--;
        }
        this._beginMove(p, chosen, speed);
      }
    } else {
      // Allow mid-tunnel reverse
      if (this.wantDir && this.wantDir === opposite(p.dir)) {
        // reverse: swap
        var tmpx = p.fx; var tmpy = p.fy;
        p.fx = p.tx; p.fy = p.ty;
        p.tx = tmpx; p.ty = tmpy;
        p.progress = 1 - p.progress;
        p.dir = this.wantDir;
        p.x = Math.round(p.fx); // will correct on arrive
      }
    }

    var arrived = this._stepEntity(p, dt, speed);
    if (arrived) this._playerArrived();
  };

  Game.prototype._chaserTarget = function (ch) {
    var p = this.player;
    if (ch.mode === 'eyes') {
      var h = this.hamperTiles[1] || this.hamperTiles[0];
      return { x: h.x, y: h.y };
    }
    if (ch.mode === 'house') {
      return { x: ch.x, y: ch.y - 1 };
    }
    if (ch.mode === 'fright') {
      // flee — maximize distance: aim away
      return { x: ch.x + (ch.x - p.x) * 2, y: ch.y + (ch.y - p.y) * 2 };
    }
    if (ch.id === 'alarm') {
      return { x: p.x, y: p.y };
    }
    if (ch.id === 'nightmare') {
      var dist = manhattan(ch.x, ch.y, p.x, p.y);
      if (dist < 6) return { x: p.x, y: p.y };
      // patrol corners
      var corners = [{ x: 1, y: 1 }, { x: 13, y: 1 }, { x: 1, y: 15 }, { x: 13, y: 15 }];
      var c = corners[ch.patrolPhase % 4];
      if (ch.x === c.x && ch.y === c.y) ch.patrolPhase++;
      return corners[ch.patrolPhase % 4];
    }
    if (ch.id === 'sock') {
      // random — pick a random open neighbor each intersection (handled in choose)
      return { x: p.x + (Math.random() < 0.5 ? 8 : -8), y: p.y + (Math.random() < 0.5 ? 8 : -8) };
    }
    if (ch.id === 'coldfeet') {
      // Cold Feet — slow, loosely pursue
      return { x: p.x, y: p.y };
    }
    return { x: p.x, y: p.y };
  };

  Game.prototype._chooseChaserDir = function (ch) {
    var opts = this._openNeighbors(ch.x, ch.y, true);
    if (!opts.length) return ch.dir;
    // never reverse unless dead end
    var filtered = opts.filter(function (d) { return d !== opposite(ch.dir); });
    if (!filtered.length) filtered = opts;

    if (ch.id === 'sock' && ch.mode === 'chase') {
      return filtered[Math.floor(Math.random() * filtered.length)];
    }

    var target = this._chaserTarget(ch);
    var best = filtered[0];
    var bestScore = ch.mode === 'fright' ? -1e9 : 1e9;
    for (var i = 0; i < filtered.length; i++) {
      var d = filtered[i];
      var nx = ch.x + DIRS[d].x, ny = ch.y + DIRS[d].y;
      var dist = manhattan(nx, ny, target.x, target.y);
      if (ch.mode === 'fright') {
        if (dist > bestScore) { bestScore = dist; best = d; }
      } else {
        if (dist < bestScore) { bestScore = dist; best = d; }
      }
    }
    return best;
  };

  Game.prototype._updateChasers = function (dt) {
    var self = this;
    var speed = this.chaserSpeed;
    this.chasers.forEach(function (ch) {
      if (ch.mode === 'house') {
        ch.houseT -= dt;
        if (ch.houseT <= 0) {
          ch.mode = 'chase';
          // leave upward if possible
          if (self._walkable(ch.x, ch.y - 1, true)) {
            self._beginMove(ch, 'up', speed * ch.speedMul);
          }
        }
        return;
      }

      if (ch.id === 'sock' && ch.mode !== 'eyes' && ch.mode !== 'fright') {
        ch.blackoutCD -= dt;
        if (ch.blackoutCD <= 0) {
          ch.blackoutCD = 8;
          self.blackoutT = 5;
          self._toast("Lost the sock. Lights out under the bed.", 2);
        }
      }

      var sp = speed * ch.speedMul * (ch.mode === 'fright' ? 0.65 : 1) * (ch.mode === 'eyes' ? 1.6 : 1);
      if (!ch.moving) {
        var d = self._chooseChaserDir(ch);
        // Alarm buzz smear on tile just left
        var leftX = ch.x, leftY = ch.y;
        if (self._beginMove(ch, d, sp)) {
          if (ch.id === 'alarm' && ch.mode === 'chase') {
            self.smears.push({ x: leftX, y: leftY, t: 4 });
          }
        }
      }
      var arrived = self._stepEntity(ch, dt, sp);
      if (arrived) {
        if (ch.mode === 'eyes') {
          var h = self.hamperTiles[1] || self.hamperTiles[0];
          if (ch.x === h.x && ch.y === h.y) {
            ch.mode = 'house';
            ch.houseT = 2;
            ch.fright = false;
          }
        }
      }
    });

    // collisions
    if (this.state !== 'PLAYING') return;
    var px = this.player.px, py = this.player.py;
    this.chasers.forEach(function (ch) {
      if (ch.mode === 'eyes' || ch.mode === 'house') return;
      var dx = ch.px - px, dy = ch.py - py;
      if (dx * dx + dy * dy < 0.45 * 0.45) {
        if (ch.mode === 'fright' || ch.fright) {
          // eat
          var pts = [200, 400, 800, 1600][Math.min(self.frightChain, 3)];
          self.frightChain++;
          self._addScore(pts);
          self.audio.eatChaser();
          self._toast(ch.name + ' · ' + pts, 1);
          ch.mode = 'eyes';
          ch.fright = false;
        } else {
          // catch
          if (ch.id === 'nightmare') {
            self._dyeBomb();
          }
          self._loseLife();
        }
      }
    });
  };

  Game.prototype._dyeBomb = function () {
    this.dyeT = 3;
    this.dyedWhite = true;
    this.audio.dye();
    this._toast('Nightmare blush. Everything’s rosy now.', 2.5);
    // Remaining soft dots become rosy + worth 0 — already flagged via dyedWhite
  };

  Game.prototype._loseLife = function () {
    if (this.state !== 'PLAYING') return;
    this._setState('DYING');
    this.deathT = 0.8;
    this.audio.death();
    // Keep nightmare-blush toast if Nightmare just tagged us
    if (this.dyeT <= 0) this._toast('Shh. Soft landing. Try again.', 1.5);
  };

  Game.prototype._respawn = function () {
    this.lives--;
    if (this.lives <= 0) {
      this._setState('GAMEOVER');
      this._toast('Shh. Soft landing. Try again.', 3);
      return;
    }
    this._setState('PLAYING');
    this.frightT = 0;
    this.blackoutT = 0;
    // reset entities, keep dots
    var spawn = this.spawn;
    this.player.x = spawn.x; this.player.y = spawn.y;
    this.player.px = spawn.x; this.player.py = spawn.y;
    this.player.dir = 'left';
    this.player.moving = false;
    this.player.slideLeft = 0;
    this.skidTurns = 0;
    var delays = [1, 3, 5, 7];
    this.chasers.forEach(function (ch, i) {
      var spot = this.hamperTiles[i] || this.hamperTiles[0];
      ch.x = spot.x; ch.y = spot.y;
      ch.px = spot.x; ch.py = spot.y;
      ch.moving = false;
      ch.mode = 'house';
      ch.houseT = delays[i];
      ch.fright = false;
      ch.blackoutCD = 8;
    }, this);
    this.smears = [];
  };

  Game.prototype._tick = function (ts) {
    if (!this.lastTs) this.lastTs = ts;
    var dt = Math.min(0.05, (ts - this.lastTs) / 1000);
    this.lastTs = ts;
    this.frame++;
    this.attractBlink += dt;

    if (this.toastT > 0) {
      this.toastT -= dt;
      if (this.toastT <= 0) {
        this.toast = null;
        if (this.hintEl) this.hintEl.textContent = '';
      }
    }

    // update smears
    for (var i = this.smears.length - 1; i >= 0; i--) {
      this.smears[i].t -= dt;
      if (this.smears[i].t <= 0) this.smears.splice(i, 1);
    }

    if (this.state === 'PLAYING') {
      if (this.frightT > 0) {
        this.frightT -= dt;
        if (this.frightT <= 0) {
          this.frightT = 0;
          this.frightChain = 0;
          this.chasers.forEach(function (ch) {
            if (ch.mode === 'fright') { ch.mode = 'chase'; ch.fright = false; }
          });
        }
      }
      if (this.blackoutT > 0) this.blackoutT -= dt;
      if (this.dyeT > 0) this.dyeT -= dt;

      this._updatePlayer(dt);
      this._updateChasers(dt);
    } else if (this.state === 'DYING') {
      if (this.dyeT > 0) this.dyeT -= dt;
      if (this.blackoutT > 0) this.blackoutT -= dt;
      this.deathT -= dt;
      if (this.deathT <= 0) this._respawn();
    } else if (this.state === 'WIN_WAVE') {
      this.winT -= dt;
      if (this.winT <= 0) this._nextBoard();
    } else if (this.state === 'ATTRACT') {
      // gentle demo: wander chasers
      this._updateChasers(dt * 0.5);
    }

    this._draw();
  };

  // --- Drawing ---
  Game.prototype._draw = function () {
    var ctx = this.ctx;
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    // re-apply letterbox scale (width AND height) — same as _resize
    var dpr = Math.min(global.devicePixelRatio || 1, 2);
    var scale = this._drawScale || this._fitScale();
    ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);

    ctx.fillStyle = '#0a0610';
    ctx.fillRect(0, 0, W, H);

    this._drawHud(ctx);
    ctx.save();
    ctx.translate(0, HUD_H);
    this._drawMaze(ctx);
    this._drawSmears(ctx);
    this._drawItems(ctx);
    if (this.state !== 'DYING' || Math.floor(this.frame / 4) % 2) {
      this._drawPlayer(ctx);
    } else {
      this._drawPlayerFlat(ctx);
    }
    this._drawChasers(ctx);
    if (this.dyeT > 0) {
      ctx.fillStyle = 'rgba(255,143,191,0.35)';
      ctx.fillRect(0, 0, W, ROWS * TILE);
    }
    ctx.restore();

    if (this.state === 'ATTRACT') this._drawAttract(ctx);
    else if (this.state === 'PAUSED') this._drawCenterMsg(ctx, 'PAUSED', 'ESC / ● to resume');
    else if (this.state === 'GAMEOVER') {
      var goSub = (layoutMode === 'mobile' || isMobileLayout())
        ? 'TAP THE STICK · Soft landing. Try again.'
        : 'SPACE / ENTER · Soft landing. Try again.';
      this._drawCenterMsg(ctx, 'GAME OVER', goSub);
    }
    else if (this.state === 'WIN_WAVE') this._drawCenterMsg(ctx, 'BEDROOM FOUND', 'Sweet dreams… next room…');

    if (this.toast && this.state === 'PLAYING') {
      ctx.fillStyle = 'rgba(10,6,16,0.65)';
      ctx.fillRect(40, H / 2 - 18, W - 80, 36);
      ctx.fillStyle = '#ff8fbf';
      ctx.font = '12px monospace';
      ctx.textAlign = 'center';
      ctx.fillText(this.toast, W / 2, H / 2 + 4);
    }
    ctx.restore();
  };

  Game.prototype._drawHud = function (ctx) {
    ctx.fillStyle = '#1a1a22';
    ctx.fillRect(0, 0, W, HUD_H);
    ctx.fillStyle = '#f4f0ea';
    ctx.font = 'bold 11px monospace';
    ctx.textAlign = 'left';
    ctx.fillText('SCORE ' + this.score, 8, 18);
    ctx.textAlign = 'center';
    ctx.fillStyle = '#ff4da6';
    ctx.fillText('BOARD ' + (this.board + 1), W / 2, 18);
    ctx.textAlign = 'right';
    ctx.fillStyle = '#f0c14b';
    ctx.fillText('HI ' + this.highScore, W - 8, 18);
    // lives (10 start — tighter spacing so row fits HUD)
    var lifeGap = this.lives > 6 ? 14 : 18;
    for (var i = 0; i < this.lives; i++) {
      this._drawPantyIcon(ctx, 8 + i * lifeGap, HUD_H - 2, 12, '#ff4da6', 'right');
    }
    if (this.audio.muted) {
      ctx.fillStyle = '#9a7284';
      ctx.font = '9px monospace';
      ctx.textAlign = 'right';
      ctx.fillText('MUTE', W - 8, HUD_H - 4);
    }
  };

  Game.prototype._drawMaze = function (ctx) {
    for (var y = 0; y < ROWS; y++) {
      for (var x = 0; x < COLS; x++) {
        var c = this.grid[y][x];
        var px = x * TILE, py = y * TILE;
        if (c.wall) {
          // Soft pillow / headboard block
          ctx.fillStyle = '#2a1830';
          ctx.beginPath();
          var wr = 6;
          ctx.moveTo(px + 1 + wr, py + 1);
          ctx.lineTo(px + TILE - 1 - wr, py + 1);
          ctx.quadraticCurveTo(px + TILE - 1, py + 1, px + TILE - 1, py + 1 + wr);
          ctx.lineTo(px + TILE - 1, py + TILE - 1 - wr);
          ctx.quadraticCurveTo(px + TILE - 1, py + TILE - 1, px + TILE - 1 - wr, py + TILE - 1);
          ctx.lineTo(px + 1 + wr, py + TILE - 1);
          ctx.quadraticCurveTo(px + 1, py + TILE - 1, px + 1, py + TILE - 1 - wr);
          ctx.lineTo(px + 1, py + 1 + wr);
          ctx.quadraticCurveTo(px + 1, py + 1, px + 1 + wr, py + 1);
          ctx.closePath();
          ctx.fill();
          ctx.fillStyle = '#ff8fbf';
          ctx.globalAlpha = 0.55;
          ctx.fillRect(px + TILE / 2 - 6, py + 5, 12, 3);
          ctx.globalAlpha = 1;
          ctx.strokeStyle = '#c9a46a';
          ctx.globalAlpha = 0.4;
          ctx.strokeRect(px + 2.5, py + 2.5, TILE - 5, TILE - 5);
          ctx.globalAlpha = 1;
        } else if (c.hamper) {
          // Cozy nest (chaser spawn)
          ctx.fillStyle = '#1a1220';
          ctx.fillRect(px, py, TILE, TILE);
          ctx.strokeStyle = '#c9a46a';
          ctx.globalAlpha = 0.55;
          ctx.strokeRect(px + 2, py + 2, TILE - 4, TILE - 4);
          ctx.globalAlpha = 1;
          ctx.fillStyle = '#ff8fbf';
          ctx.globalAlpha = 0.25;
          ctx.beginPath();
          ctx.ellipse(px + TILE / 2, py + TILE / 2 + 2, 8, 4, 0, 0, Math.PI * 2);
          ctx.fill();
          ctx.globalAlpha = 1;
        } else if (c.puddle) {
          ctx.fillStyle = 'rgba(255,143,191,0.25)';
          ctx.beginPath();
          ctx.ellipse(px + TILE / 2, py + TILE / 2 + 2, 8, 5, 0, 0, Math.PI * 2);
          ctx.fill();
        } else if (c.pearl) {
          ctx.fillStyle = '#e8d5a3';
          ctx.globalAlpha = 0.4;
          for (var k = 0; k < 3; k++) {
            ctx.beginPath();
            ctx.arc(px + 6 + k * 6, py + TILE / 2, 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.globalAlpha = 1;
        }
        if (c.exit) {
          var open = this.exitOpen;
          ctx.fillStyle = open ? '#3a2840' : '#1a1220';
          ctx.fillRect(px + 5, py + 4, TILE - 10, TILE - 8);
          ctx.strokeStyle = open ? '#c9a46a' : '#5a5a66';
          ctx.lineWidth = 2;
          ctx.strokeRect(px + 5, py + 4, TILE - 10, TILE - 8);
          ctx.fillStyle = open ? '#ff8fbf' : '#4a3a55';
          ctx.fillRect(px + TILE / 2 - 6, py + 8, 12, 5);
          ctx.fillStyle = open ? '#c9a46a' : '#3a3a44';
          ctx.font = '7px monospace';
          ctx.textAlign = 'center';
          ctx.fillText(open ? 'BED' : 'ZZZ', px + TILE / 2, py + TILE - 8);
          ctx.lineWidth = 1;
        }
      }
    }
  };

  Game.prototype._drawSmears = function (ctx) {
    this.smears.forEach(function (s) {
      ctx.fillStyle = 'rgba(232,160,184,' + clamp(s.t / 4, 0, 0.55) + ')';
      ctx.fillRect(s.x * TILE + 4, s.y * TILE + TILE - 6, TILE - 8, 4);
    });
  };

  Game.prototype._drawItems = function (ctx) {
    for (var y = 0; y < ROWS; y++) {
      for (var x = 0; x < COLS; x++) {
        var c = this.grid[y][x];
        var px = x * TILE + TILE / 2, py = y * TILE + TILE / 2;
        if (c.dot) {
          ctx.fillStyle = (c.white && this.dyedWhite) ? '#ff8fbf' : (c.white ? '#f4f0ea' : '#ff8fbf');
          this._drawMiniHeart(ctx, px, py, 3.2);
        }
        if (c.bag) {
          // power pillow
          ctx.fillStyle = '#f0c14b';
          ctx.beginPath();
          ctx.ellipse(px, py + 1, 7, 5, 0, 0, Math.PI * 2);
          ctx.fill();
          ctx.strokeStyle = '#ff8fbf';
          ctx.stroke();
          ctx.fillStyle = '#ff4da6';
          ctx.beginPath();
          ctx.moveTo(px, py - 4);
          ctx.quadraticCurveTo(px + 3, py - 1, px, py + 2);
          ctx.quadraticCurveTo(px - 3, py - 1, px, py - 4);
          ctx.fill();
        }
        if (c.bra) {
          // bonus moon
          ctx.fillStyle = '#e8d5a3';
          ctx.beginPath();
          ctx.arc(px, py, 5, 0, Math.PI * 2);
          ctx.fill();
          ctx.fillStyle = '#0a0610';
          ctx.beginPath();
          ctx.arc(px + 2, py - 1, 4, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    }
  };

  Game.prototype._drawMiniHeart = function (ctx, cx, cy, r) {
    ctx.beginPath();
    ctx.moveTo(cx, cy + r * 0.7);
    ctx.bezierCurveTo(cx - r * 1.4, cy - r * 0.2, cx - r * 0.6, cy - r * 1.2, cx, cy - r * 0.45);
    ctx.bezierCurveTo(cx + r * 0.6, cy - r * 1.2, cx + r * 1.4, cy - r * 0.2, cx, cy + r * 0.7);
    ctx.closePath();
    ctx.fill();
  };

  Game.prototype._drawSleepyHeart = function (ctx, cx, cy, size, color, facing, outlineColor) {
    ctx.save();
    ctx.translate(cx, cy);
    var ox = facing === 'left' ? -1 : facing === 'right' ? 1 : 0;
    var oy = facing === 'up' ? -1 : facing === 'down' ? 1 : 0;
    ctx.translate(ox, oy);
    ctx.fillStyle = color || '#ff8fbf';
    this._drawMiniHeart(ctx, 0, 0, size * 0.42);
    if (outlineColor) {
      ctx.strokeStyle = outlineColor;
      ctx.lineWidth = 2;
      ctx.shadowColor = outlineColor;
      ctx.shadowBlur = 3;
      ctx.beginPath();
      ctx.moveTo(0, size * 0.3);
      ctx.bezierCurveTo(-size * 0.55, -size * 0.08, -size * 0.25, -size * 0.5, 0, -size * 0.18);
      ctx.bezierCurveTo(size * 0.25, -size * 0.5, size * 0.55, -size * 0.08, 0, size * 0.3);
      ctx.closePath();
      ctx.stroke();
      ctx.shadowBlur = 0;
      ctx.lineWidth = 1;
    }
    ctx.strokeStyle = '#3a2840';
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(-size * 0.16, -size * 0.02);
    ctx.quadraticCurveTo(-size * 0.1, size * 0.04, -size * 0.04, -size * 0.02);
    ctx.moveTo(size * 0.04, -size * 0.02);
    ctx.quadraticCurveTo(size * 0.1, size * 0.04, size * 0.16, -size * 0.02);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(-size * 0.06, size * 0.1);
    ctx.quadraticCurveTo(0, size * 0.16, size * 0.06, size * 0.1);
    ctx.stroke();
    ctx.fillStyle = '#c9a46a';
    ctx.font = 'bold ' + Math.max(7, Math.floor(size * 0.32)) + 'px monospace';
    ctx.textAlign = 'left';
    ctx.fillText('z', size * 0.22, -size * 0.28);
    ctx.font = 'bold ' + Math.max(6, Math.floor(size * 0.26)) + 'px monospace';
    ctx.fillText('z', size * 0.34, -size * 0.42);
    ctx.restore();
  };

  Game.prototype._drawPantyIcon = function (ctx, cx, cy, size, color, facing, outlineColor) {
    this._drawSleepyHeart(ctx, cx, cy, size, color || '#ff8fbf', facing, outlineColor);
  };

  Game.prototype._drawPlayer = function (ctx) {
    var p = this.player;
    var cx = p.px * TILE + TILE / 2;
    var cy = p.py * TILE + TILE / 2;
    this._drawSleepyHeart(ctx, cx, cy, 38, '#ff8fbf', p.dir, '#fff');
  };

  Game.prototype._drawPlayerFlat = function (ctx) {
    var p = this.player;
    var cx = p.px * TILE + TILE / 2;
    var cy = p.py * TILE + TILE / 2;
    ctx.fillStyle = '#ff8fbf';
    ctx.globalAlpha = 0.7;
    this._drawMiniHeart(ctx, cx, cy + 2, 6);
    ctx.globalAlpha = 1;
    ctx.fillStyle = '#c9a46a';
    ctx.font = '8px monospace';
    ctx.textAlign = 'center';
    ctx.fillText('z', cx + 8, cy - 4);
  };

  Game.prototype._drawChasers = function (ctx) {
    var blackout = this.blackoutT > 0;
    var flash = this.frightT > 0 && this.frightT < 2 && Math.floor(this.frame / 8) % 2;
    this.chasers.forEach(function (ch) {
      var cx = ch.px * TILE + TILE / 2;
      var cy = ch.py * TILE + TILE / 2;
      if (ch.mode === 'eyes') {
        ctx.fillStyle = '#f4f0ea';
        ctx.fillRect(cx - 5, cy - 2, 3, 3);
        ctx.fillRect(cx + 2, cy - 2, 3, 3);
        ctx.fillStyle = '#3a6ad9';
        ctx.fillRect(cx - 4, cy - 1, 2, 2);
        ctx.fillRect(cx + 3, cy - 1, 2, 2);
        return;
      }
      if (blackout && ch.mode !== 'house') {
        ctx.fillStyle = '#f4f0ea';
        ctx.fillRect(cx - 1, cy - 1, 2, 2);
        return;
      }
      var col = ch.color;
      if (ch.mode === 'fright' || ch.fright) {
        col = flash ? '#f4f0ea' : '#2a3a6a';
      }
      if (ch.id === 'alarm') {
        ctx.fillStyle = col;
        ctx.beginPath();
        ctx.arc(cx, cy + 1, 8, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#f4f0ea';
        ctx.beginPath();
        ctx.arc(cx, cy + 1, 5, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = '#3a2840';
        ctx.lineWidth = 1.2;
        ctx.beginPath();
        ctx.moveTo(cx, cy + 1);
        ctx.lineTo(cx, cy - 2);
        ctx.moveTo(cx, cy + 1);
        ctx.lineTo(cx + 3, cy + 3);
        ctx.stroke();
        ctx.fillStyle = col;
        ctx.beginPath();
        ctx.arc(cx - 5, cy - 6, 3, 0, Math.PI * 2);
        ctx.arc(cx + 5, cy - 6, 3, 0, Math.PI * 2);
        ctx.fill();
        ctx.lineWidth = 1;
      } else if (ch.id === 'nightmare') {
        ctx.fillStyle = col;
        ctx.beginPath();
        ctx.arc(cx - 5, cy + 1, 5, 0, Math.PI * 2);
        ctx.arc(cx + 5, cy + 1, 5, 0, Math.PI * 2);
        ctx.arc(cx, cy - 3, 6, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#f4f0ea';
        ctx.fillRect(cx - 5, cy - 2, 3, 3);
        ctx.fillRect(cx + 2, cy - 2, 3, 3);
        ctx.strokeStyle = '#3a2840';
        ctx.beginPath();
        ctx.moveTo(cx - 3, cy + 5);
        ctx.quadraticCurveTo(cx, cy + 3, cx + 3, cy + 5);
        ctx.stroke();
      } else if (ch.id === 'sock') {
        ctx.fillStyle = col;
        ctx.beginPath();
        ctx.moveTo(cx - 5, cy - 8);
        ctx.lineTo(cx + 4, cy - 8);
        ctx.lineTo(cx + 5, cy + 2);
        ctx.lineTo(cx + 8, cy + 7);
        ctx.lineTo(cx + 2, cy + 9);
        ctx.lineTo(cx - 5, cy + 4);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = '#f4f0ea';
        ctx.globalAlpha = 0.35;
        ctx.fillRect(cx - 3, cy - 6, 5, 3);
        ctx.globalAlpha = 1;
      } else if (ch.id === 'coldfeet') {
        ctx.fillStyle = col;
        ctx.beginPath();
        ctx.ellipse(cx - 4, cy + 1, 4, 6, -0.2, 0, Math.PI * 2);
        ctx.ellipse(cx + 4, cy + 1, 4, 6, 0.2, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#f4f0ea';
        ctx.beginPath();
        ctx.arc(cx - 4, cy - 4, 2, 0, Math.PI * 2);
        ctx.arc(cx + 4, cy - 4, 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#a8d4ff';
        ctx.fillRect(cx - 1, cy + 6, 2, 2);
      }
    }, this);
  };

  Game.prototype._drawAttract = function (ctx) {
    ctx.fillStyle = 'rgba(10,6,16,0.72)';
    ctx.fillRect(24, 80, W - 48, 280);
    ctx.strokeStyle = '#ff4da6';
    ctx.strokeRect(24.5, 80.5, W - 49, 279);
    ctx.fillStyle = '#ff4da6';
    ctx.font = 'bold 22px monospace';
    ctx.textAlign = 'center';
    ctx.fillText('SLEEPY HEARTS MAZE', W / 2, 130);
    ctx.fillStyle = '#ff8fbf';
    ctx.font = '12px monospace';
    ctx.fillText('find the bedroom. don’t wake the alarm.', W / 2, 158);
    ctx.fillStyle = '#f4f0ea';
    ctx.font = '11px monospace';
    ctx.fillText('ARROWS / WASD  •  PILLOW = POWER', W / 2, 190);
    ctx.fillText('Collect every heart → bedroom door', W / 2, 212);
    ctx.fillText('Alarm · Nightmare · Lost Sock · Cold Feet', W / 2, 234);
    ctx.fillStyle = '#f0c14b';
    ctx.fillText('HIGH SCORE  ' + this.highScore, W / 2, 268);
    if (Math.floor(this.attractBlink * 2) % 2 === 0) {
      ctx.fillStyle = '#ff4da6';
      ctx.font = 'bold 13px monospace';
      var startPrompt = (layoutMode === 'mobile' || isMobileLayout())
        ? 'TAP THE STICK TO START'
        : 'STEER OR PRESS SPACE';
      ctx.fillText(startPrompt, W / 2, 310);
    }
    ctx.fillStyle = '#9a7284';
    ctx.font = '10px monospace';
    ctx.fillText('M mute · ESC pause', W / 2, 340);
  };

  Game.prototype._drawCenterMsg = function (ctx, title, sub) {
    ctx.fillStyle = 'rgba(10,6,16,0.75)';
    ctx.fillRect(40, H / 2 - 50, W - 80, 100);
    ctx.strokeStyle = '#ff4da6';
    ctx.strokeRect(40.5, H / 2 - 49.5, W - 81, 99);
    ctx.fillStyle = '#ff4da6';
    ctx.font = 'bold 18px monospace';
    ctx.textAlign = 'center';
    ctx.fillText(title, W / 2, H / 2 - 10);
    ctx.fillStyle = '#ff8fbf';
    ctx.font = '11px monospace';
    ctx.fillText(sub, W / 2, H / 2 + 18);
  };

  // Validate both layout packs at boot.
  function validateMazes(pack, label, cols, rows) {
    pack.forEach(function (m, i) {
      if (m.length !== rows) console.warn(label + ' maze', i, 'rows', m.length);
      m.forEach(function (row, y) {
        if (row.length !== cols) console.warn(label + ' maze', i, 'row', y, 'len', row.length, row);
      });
    });
  }
  validateMazes(MAZES_MOBILE, 'Mobile', MOBILE_LAYOUT.cols, MOBILE_LAYOUT.rows);
  validateMazes(MAZES_DESKTOP, 'Desktop', DESKTOP_LAYOUT.cols, DESKTOP_LAYOUT.rows);

  function boot(root) {
    if (!root) return null;
    if (root.__klSleepyHeartsMaze || root.__klDrawerMaze) return root.__klSleepyHeartsMaze || root.__klDrawerMaze;
    setLayoutMode(layoutModeForViewport());
    var g = new Game(root);
    root.__klSleepyHeartsMaze = g;
    root.__klDrawerMaze = g;
    return g;
  }

  global.KLSleepyHeartsMaze = { boot: boot, TILE: TILE, W: W, H: H };
  global.KLDrawerMaze = global.KLSleepyHeartsMaze; // same parlor asset path

  /* KL HARD LOCK 2026-09-17 Katie: remove Shopify draft/preview bar (late JS inject) */
  function nukeShopifyPreviewBar() {
    var sels = [
      '#preview-bar-iframe',
      'iframe#preview-bar-iframe',
      'iframe[src*="preview_bar"]',
      'iframe[src*="preview-bar"]',
      '.shopify-preview-bar',
      '#shopify-preview-bar',
      '.preview-bar',
      '#PreviewBarCSS',
      '[data-preview-bar]'
    ];
    sels.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (el) { el.remove(); });
    });
    try {
      document.documentElement.style.marginBottom = '0';
      document.body.style.marginBottom = '0';
      document.body.style.paddingBottom = '0';
    } catch (e) {}
  }
  nukeShopifyPreviewBar();
  if (window.MutationObserver) {
    var __klPreviewBarMo = new MutationObserver(function () { nukeShopifyPreviewBar(); });
    __klPreviewBarMo.observe(document.documentElement, { childList: true, subtree: true });
  }


  function auto() {
    var root = document.querySelector('[data-kl-drawer-maze]') || document.getElementById('kl-drawer-maze-root');
    if (!root) return;
    var g = boot(root);
    if (!g) return;
    /* After DOM ready + canvas in tree — refit once layout has real stage size. */
    try { g._scheduleLayoutFit(); } catch (eFit) {}
    /* Quit → /pages/arcade-games (Katie 2026-09-17) */
    if (!root.querySelector('[data-kl-quit]')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kl-dm__quit';
      btn.setAttribute('data-kl-quit', '');
      btn.setAttribute('aria-label', 'Quit to Arcade');
      btn.textContent = 'Quit';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        try {
          var game = root.__klSleepyHeartsMaze || root.__klDrawerMaze || g;
          if (game && typeof game.destroy === 'function') game.destroy();
        } catch (e) {}
        location.href = '/pages/arcade-games';
      });
      root.appendChild(btn);
      if (typeof suppressIosCallout === 'function') suppressIosCallout(btn, false);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();
})(typeof window !== 'undefined' ? window : this);
